import * as React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

export type ExternalLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

function ExternalLink({
    children,
    ...props
}: React.PropsWithChildren<ExternalLinkProps>) {
    return <OutboundLink {...props}>{children}</OutboundLink>;
}

ExternalLink.defaultProps = {
    rel: 'noopener noreferrer',
    target: '_blank',
};

export default ExternalLink;
